
export interface PreliminaryValue {
	value: string;
	other?: string;
}

export type Preliminaries = 'age' | 'gender' | 'education' | 'firstlanguage' | 'activity' | 'fillreason';

export const NoAnswer = 'noAnswer';